import React from "react";

const ApplicationClosed = () => {
  return (
    <div className="td_notfound_wrapper">
      <div className="td_notfound_card">
        {/* Font Awesome Clock/Calendar Icon */}
        <div className="td_notfound_icon_wrapper">
          <i className="fa-regular fa-calendar-xmark td_notfound_icon_fa"></i>
        </div>

        <h2 className="td_fs_32 td_bold td_heading_color td_mb_20">
          Application Deadline Has Passed
        </h2>

        <p className="td_fs_18 td_medium_color td_mb_30">
          Thank you for your interest. The application period has now closed,
          and we are no longer accepting new submissions.
        </p>

        <div className="td_notfound_info_box td_mb_30">
          <p className="td_fs_16">
            Please check our vacancy page regularly for future opportunities or
            contact <strong>University of Nepal</strong> if you need additional
            information.
          </p>
        </div>

        <div className="td_notfound_actions">
          <a href="/" className="td_btn_primary">
            <i className="fa-solid fa-house"></i> Back to Home
          </a>

          <button
            className="td_btn_secondary"
            onClick={() => window.history.back()}
          >
            <i className="fa-solid fa-arrow-left"></i> Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationClosed;
